$.fn.paymentCalculator = function(options) {

  var defaults = {
    afterAddingForm: $.noop
  };

  var settings = $.extend({}, defaults, options);

  return this.each(function() {

    var adding_form_button = $(this).find('.adding-form');
    var calculator_container = $(this).find('.calculator-container');
    var calculator_group = $(this).find('.calculator-group');
    var calculator_result = $(this).find('.tool-result');
    var calculator_print = $(this).find('.tool-print');
    var calculator_counter = 1;

    var summe_abfuehrung_verguetung_element = $(this).find('.summe-abfuehrung-verguetung');
    var summe_eigenbehalt_verguetung_element = $(this).find('.summe-eigenbehalt-verguetung');
    var summe_abfuehrung_sitzungsgelder_element = $(this).find('.summe-abfuehrung-sitzungsgelder');
    var summe_eigenbehalt_sitzungsgelder_element = $(this).find('.summe-eigenbehalt-sitzungsgelder');

    var summe_abfuehrung_gesamt_element =  $(this).find('.summe-abfuehrung-gesamt');
    var summe_eigenbehalt_gesamt_element =  $(this).find('.summe-eigenbehalt-gesamt');

    addingForm(calculator_counter, calculator_container, calculator_group.clone());

    calculator_group.detach();

    adding_form_button.on('click', function(e) {
      calculator_counter += 1;
      addingForm(calculator_counter, calculator_container, calculator_group.clone());
      settings.afterAddingForm.call(this);
      e.preventDefault();
    });

    calculator_container.on('change keyup paste', function(e) {

      var summe_abfuehrung_verguetung_value = 0;
      var summe_eigenbehalt_verguetung_value = 0;
      var summe_abfuehrung_sitzungsgelder_value = 0;
      var summe_eigenbehalt_sitzungsgelder_value = 0;
      var summe_abfuehrung_gesamt_value = 0;
      var summe_eigenbehalt_gesamt_value = 0;

      $(this).find('input[name^="verguetung_abfuehrung"]').each(function(index, element) {
        summe_abfuehrung_verguetung_value += parseFloat($(this).val());
      });

      $(this).find('input[name^="verguetung_eigenbehalt"]').each(function(index, element) {
        summe_eigenbehalt_verguetung_value += parseFloat($(this).val());
      });

      $(this).find('input[name^="sitzungsgelder_abfuehrung"]').each(function(index, element) {
        summe_abfuehrung_sitzungsgelder_value += parseFloat($(this).val());
      });

      $(this).find('input[name^="sitzungsgelder_eigenbehalt"]').each(function(index, element) {
        summe_eigenbehalt_sitzungsgelder_value += parseFloat($(this).val());
      });

      summe_abfuehrung_verguetung_element.html(getFormated(summe_abfuehrung_verguetung_value) + ' €');
      summe_eigenbehalt_verguetung_element.html(getFormated(summe_eigenbehalt_verguetung_value) + ' €');
      summe_abfuehrung_sitzungsgelder_element.html(getFormated(summe_abfuehrung_sitzungsgelder_value) + ' €');
      summe_eigenbehalt_sitzungsgelder_element.html(getFormated(summe_eigenbehalt_sitzungsgelder_value) + ' €');

      summe_abfuehrung_gesamt_value = summe_abfuehrung_verguetung_value + summe_abfuehrung_sitzungsgelder_value;
      summe_eigenbehalt_gesamt_value = summe_eigenbehalt_verguetung_value + summe_eigenbehalt_sitzungsgelder_value;

      summe_abfuehrung_gesamt_element.html(getFormated(summe_abfuehrung_gesamt_value) + ' €');
      summe_eigenbehalt_gesamt_element.html(getFormated(summe_eigenbehalt_gesamt_value) + ' €');

      if (summe_abfuehrung_gesamt_value || summe_eigenbehalt_gesamt_value) {
        calculator_result.slideDown();
        calculator_print.show();
      }

    });
  });

  function addingForm(counter, container, group) {
    var mandat_element = group.find('select[name^="mandat"]');
    var mitgliedschaften_element = group.find('input[name^="mitgliedschaften"]');
    var aufsichtsratverguetung_element = group.find('input[name^="aufsichtsratverguetung"]');
    var sitzungsgelder_gesamt_element = group.find('input[name^="sitzungsgelder_gesamt"]');
    var keine_aufsichtsratverguetung = group.find('input[name^="keine_aufsichtsratverguetung"]');

    var verguetung_abfuehrung_element = group.find('input[name^="verguetung_abfuehrung"]');
    var verguetung_eigenbehalt_element = group.find('input[name^="verguetung_eigenbehalt"]');
    var sitzungsgelder_abfuehrung_element = group.find('input[name^="sitzungsgelder_abfuehrung"]');
    var sitzungsgelder_eigenbehalt_element = group.find('input[name^="sitzungsgelder_eigenbehalt"]');

    var verguetung_obergrenze_value = 0;
    var verguetung_abfuehrung_value = 0;
    var verguetung_eigenbehalt_value = 0;
    var sitzungsgelder_obergrenze_value = 0;
    var sitzungsgelder_abfuehrung_value = 0;
    var sitzungsgelder_eigenbehalt_value = 0;

    group.find('label').each(function(index, label) {
      $(this).attr('for', $(this).attr('for') + '_' + counter);
    });

    group.find('input, select').each(function(index, input) {
      $(this).attr('id', $(this).attr('id') + '_' + counter);
      $(this).attr('name', $(this).attr('name') + '_' + counter);
    });

    group.find('.calc').on('change keyup paste', function() {

      verguetung_abfuehrung_element.val(getFixed(0));
      verguetung_eigenbehalt_element.val(getFixed(0));
      sitzungsgelder_abfuehrung_element.val(getFixed(0));
      sitzungsgelder_eigenbehalt_element.val(getFixed(0));
      
      // aufsichtsratverguetung
      if (getInt(aufsichtsratverguetung_element)) {

        if (getInt(mitgliedschaften_element)) {
          verguetung_obergrenze_value = getInt(mandat_element) + (getInt(mitgliedschaften_element) * 2500);
        } else {
          verguetung_obergrenze_value = getInt(mandat_element);
        }

        if (getInt(aufsichtsratverguetung_element) <= verguetung_obergrenze_value) {
          verguetung_abfuehrung_value = (getInt(aufsichtsratverguetung_element) * 0.1);
        } else {
          verguetung_abfuehrung_value = (verguetung_obergrenze_value * 0.1) + ((getInt(aufsichtsratverguetung_element) - verguetung_obergrenze_value) * 0.9);
        }
        
        verguetung_eigenbehalt_value = getInt(aufsichtsratverguetung_element) - verguetung_abfuehrung_value;

        verguetung_abfuehrung_element.val(getFixed(verguetung_abfuehrung_value));
        verguetung_eigenbehalt_element.val(getFixed(verguetung_eigenbehalt_value));
      }

      // sitzungsgelder
      if (getInt(sitzungsgelder_gesamt_element)) {

        var sitzungsgelder_value = 0;

        if (getInt(aufsichtsratverguetung_element) && keine_aufsichtsratverguetung.prop('checked') && getInt(mitgliedschaften_element)) {
          sitzungsgelder_value = getInt(aufsichtsratverguetung_element) + getInt(sitzungsgelder_gesamt_element);
          sitzungsgelder_obergrenze_value = getInt(mandat_element) + (getInt(mitgliedschaften_element) * 2500);

          if (sitzungsgelder_value <= sitzungsgelder_obergrenze_value) {
            sitzungsgelder_abfuehrung_value = (sitzungsgelder_value * 0.1);
          } else {
            sitzungsgelder_abfuehrung_value = (sitzungsgelder_obergrenze_value * 0.1) + ((sitzungsgelder_value - sitzungsgelder_obergrenze_value) * 0.9);
          }

          verguetung_abfuehrung_element.val(getFixed(0));
          verguetung_eigenbehalt_element.val(getFixed(0));
         
          sitzungsgelder_eigenbehalt_value = sitzungsgelder_value - sitzungsgelder_abfuehrung_value;
          sitzungsgelder_abfuehrung_element.val(getFixed(sitzungsgelder_abfuehrung_value));
          sitzungsgelder_eigenbehalt_element.val(getFixed(sitzungsgelder_eigenbehalt_value));

        } else if (!getInt(aufsichtsratverguetung_element) && keine_aufsichtsratverguetung.prop('checked')) {

          sitzungsgelder_value = getInt(sitzungsgelder_gesamt_element);
          sitzungsgelder_obergrenze_value = getInt(mandat_element);

          if (sitzungsgelder_value <= sitzungsgelder_obergrenze_value) {
            sitzungsgelder_abfuehrung_value = (sitzungsgelder_value * 0.1);
          } else {
            sitzungsgelder_abfuehrung_value = (sitzungsgelder_obergrenze_value * 0.1) + ((sitzungsgelder_value - sitzungsgelder_obergrenze_value) * 0.9);
          }
         
          sitzungsgelder_eigenbehalt_value = sitzungsgelder_value - sitzungsgelder_abfuehrung_value;
          sitzungsgelder_abfuehrung_element.val(getFixed(sitzungsgelder_abfuehrung_value));
          sitzungsgelder_eigenbehalt_element.val(getFixed(sitzungsgelder_eigenbehalt_value));
          
        } else {

          if (getInt(sitzungsgelder_gesamt_element) <= 2000) {
            sitzungsgelder_abfuehrung_value = 0;
          } else if(getInt(sitzungsgelder_gesamt_element) >= 2001 && getInt(sitzungsgelder_gesamt_element) <= 4000) {
            sitzungsgelder_abfuehrung_value = (getInt(sitzungsgelder_gesamt_element) - 2000) * 0.1;
          } else if(getInt(sitzungsgelder_gesamt_element) >= 4001) {
            sitzungsgelder_abfuehrung_value = (2000 * 0.1) + ((getInt(sitzungsgelder_gesamt_element) - 4000) * 0.9);
          }

          sitzungsgelder_eigenbehalt_value = getInt(sitzungsgelder_gesamt_element) - sitzungsgelder_abfuehrung_value;
          sitzungsgelder_abfuehrung_element.val(getFixed(sitzungsgelder_abfuehrung_value));
          sitzungsgelder_eigenbehalt_element.val(getFixed(sitzungsgelder_eigenbehalt_value));
        }
      }

    });

    container.append(group);
  }

  function getInt(element) {
    var value = parseInt((element.val()).replace(/\./g,''));
    if (isNaN(value)) {
      return false;
    } else {
      return value;
    }
  }

  function getFixed(value) {
    return (Math.round(value * 10) / 10).toFixed(2);
  }

  function getFormated(value) {
    return value.toFixed(2).toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }
};
